<template>
  <i v-if="visible" 
    :class="icnClasses" 
    :style="styleObj"
    style="cursor: pointer; position: relative;" 
    :id="configs.ID"
    aria-hidden="true"
    @click.prevent="exec.apply(this, execParam)"
    @mouseover="mouse_over" @mouseleave="mouse_leave">
    <span v-if="count>0" class="notifCount" :id="configs.ID +'_counter'"> 
      <span>{{count}}</span>
    </span>
  </i>
</template>

<script>
export default {
  name: "Icons",
  props: {
    configs: {
      type: Object,
      default: function() {
        return {
          ID: null
        };
      }
    },
    //funzione eseguita all'onclick
    exec: {
      type: Function,
      default() {
        console.log(this.configs.ID + " clicked");
      }
    },
    //parametro da passare alla funzione exec (facoltativo)
    execParam: {
      type: Array,
      default: null
    },
    /* //funzione eseguita al mouseover
    hover: {
      type: Function,
      default() {
        console.log(this.configs.ID + " hovered");
      }
    }, */
    //parametro da passare alla funzione hover (facoltativo)
    hoverParam: {
      type: String,
      default: null
    },
    // stile inline applicato a i
    styleObj: {
      type: Object,
      default: function() {
        return {};
      }
    },
    //classi css applicate a i
    icnClasses: {
      type: Array,
      default: null
    },
    //numero di contenuti da mostrare sull'icona
    count:{
      type: Number,
      default: 0
    }
  },
  mounted: function() {
    if (this.configs.ID != null) {
      this.init();
    }
  },
  data: function() {
    return {
      visible: false,
      timeoutID: '',
      enableTooltip: true
    };
  },
  methods: {
    init: function() {
      var merged_c = this.configs;
      this.visible = merged_c.visible;

      // se l'icona non è visibile, lo segnalo al genitore (che eventualmente si può adattare)
      if (!this.visible) {
        this.$emit("invisible");
      }

      //se sono su un dispositivo desktop abilito i tooltip (e se sono nel caso senza icona che attiva modalità aiuto)
      if(sessionStorage.getItem('device') == 'desktop' && !this.$Behaviors.showHelpModeIcon){
        this.enableTooltip = true
      }else{
        this.enableTooltip = false
      }
    },
    mouse_over: function(){
      if(this.enableTooltip){
        //console.log('OVER: ', this.configs.ID)
        this.timeoutID = setTimeout(()=>{
          this.$root.help = true;
          this.$root.trigger_help(this.hoverParam)
        }, this.$Behaviors.tooltipTimeout)
      }
    },
    mouse_leave: function(){
      if(this.enableTooltip){
        //console.log('LEAVE: ', this.configs.ID)
        clearTimeout(this.timeoutID)
        this.$root.help = false;
        this.$root.trigger_help(this.hoverParam)
      }
    }
  }
};
</script>

<style scoped>
.notifCount{
  left: 60%;
  bottom: 50%;
  background-color: #ef3030;
  position: absolute;
  border-radius: 2px;
  height: 18px;
  width: 15px;
  padding: 1px 3px;
}
.notifCount>span{
  font-size: 14px;
  font-weight: 500;
  color: white;
  font-family: Source Sans Pro;
  position: absolute;
  top: 10%;
  right: 20%;
}
</style>


// WEBPACK FOOTER //
// src/components/dynamic/DynIcon.vue?3b58a19d